import type { LucideIcon } from 'lucide-react';
import { TrendingUp } from 'lucide-react';

interface StatCardProps {
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
  label: string;
  value: string;
  subtitle?: string;
  trend?: string;
  trendColor?: string;
}

export default function StatCard({
  icon: Icon,
  iconBg,
  iconColor,
  label,
  value,
  subtitle,
  trend,
  trendColor = 'text-emerald-600',
}: StatCardProps) {
  return (
    <div className='stat-card'>
      <div className='flex items-start justify-between mb-4'>
        <div className={`w-12 h-12 ${iconBg} rounded-xl flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
        {trend && (
          <span className={`${trendColor} text-sm font-bold flex items-center gap-1`}>
            {trend.startsWith('+') && <TrendingUp className='w-4 h-4' />}
            {trend}
          </span>
        )}
      </div>
      <p className='text-slate-500 text-sm mb-1'>{label}</p>
      <p className='text-3xl font-extrabold text-slate-900'>{value}</p>
      <p className='text-xs text-slate-400 mt-2'>{subtitle}</p>
    </div>
  );
}
